module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_axios@0.21.1@axios/index.js
// module id = 21
// module chunks = 0